<template>
  <Modal :id="'cmp-settings-label-add-config'" @cancelled="onCancel">
    <template slot="header">{{ $t('add_config') }}</template>
    <template slot="body">
      <div class="form-group">
        <Dropdown
          :options="apiSources"
          :selected="apiSources.find((e) => e.value == form_name)"
          class="m1"
          :placeholder="$t('source')"
          v-on:selectedChange="(e) => onSourceChange(e)"
          :listHeight="95"
          box
        />
        <DynamicForm
          :forms="forms"
          :formsData="formsData"
          :textFieldConfig="textFieldConfig"
          @changed="({ name, value }) => onDynamicFormChange({ name, value })"
          @validated="onDNValidated"
        />
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
      <button
        @click.stop="onFormSubmit"
        class="dt-button v1 s6"
        :class="{
          disabled: !isFormValid(),
        }"
        :disabled="!isFormValid()"
      >
        {{ $t("add") }}
      </button>
    </template>
  </Modal>
</template>
<script>
import DynamicForm from "@plugins/form-builder/dynamic-form";
import Modal from "@dtplugins/modal/modal";
import {
  createFormModalMixin,
  createFormItemMixin,
} from "../../../../dt-plugins/form-modal/form-modal";
import { LabelSettingsService } from "../../services/label-settings.service";
import {
  createTextFieldConfig,
  EventHooks,
  createValidator,
} from "../../../../plugins/text-field";
import { createForm } from "../../../../plugins/form-builder/form.model";
import { showError } from "../../../../dt-plugins/notification/notification.service";

export default {
  components: {
    Modal,
    DynamicForm,
  },
  props: ["labelSettingsData", "apiForms"],
  mixins: [],
  data: function () {
    return {
      formsData: null,

      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,

        validationEvent: EventHooks.OnKeyup,
        valueChangedEvent: EventHooks.OnBlur,

        immediateValidation: true,
      },

      formValidation: {},
    };
  },
  computed: {
    apiSources: function () {
      return (
        Object.keys(
          this.labelSettingsData?.translator_api_configs_structure || []
        ).map((e) => {
          return {
            text: e,
            value: e,
          };
        }) || []
      );
    },
    form_name() {
      return this.$route.query?.form_name;
    },
    form_structure: function () {
      return (
        this.labelSettingsData?.translator_api_configs_structure?.[
          this.form_name
        ] || []
      );
    },
    api_data: function () {
      return (
        this.labelSettingsData?.translator_api_configs?.[this.form_name] || []
      );
    },
    forms() {
      return this.apiForms?.find((e) => e?.form_name == this.form_name)?.form;
    },
    // forms: function () {
    //   const forms =
    //     this.labelSettingsData?.translator_api_configs_structure?.[this.form_name]?.map(
    //       (form) =>
    //         createForm({
    //           name: form.name,
    //           required: form.required == "required",
    //           field_name: form.field_name,
    //           showValidationIcons: form.required == "required" ? true : false,
    //           ...(form.unique == "unique"
    //             ? {
    //                 validators: [
    //                   createValidator({
    //                     name: "duplicate",
    //                     validatorFn: (value) => {
    //                       const dup = this.api_data.find((e) => e[form.name] == value);
    //                       if (dup) {
    //                         return false;
    //                       } else {
    //                         return true;
    //                       }
    //                     },
    //                     errorMessage: `Duplicate ${form.name} Exists`,
    //                   }),
    //                 ],
    //               }
    //             : {}),
    //         })
    //     ) || [];
    //   return forms;
    // },
  },
  methods: {
    isFormValid: function () {
      return Object.keys(this.formValidation)
        .map((key) => this.formValidation[key].valid)
        .every((e) => e);
    },
    onSourceChange: function (value) {
      this.formsData = null;
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          form_name: value.value,
        },
      });
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onDynamicFormChange: function ({ name, value }) {
      const { unique } = this.form_structure.find((e) => e.name == name);
      // if (unique && unique == "unique") {
      //   const dup = this.api_data.find(e => e[name] == value);
      //   if (dup) {
      //     showError(`${name} with value ${value} already Exists`);
      //     createValidator({
      //       name: 'required',
      //       validatorFn: stringRequired,
      //       errorMessage: `${this.placeholder} Can't be empty`
      //     })
      //     return;
      //   }
      // }
      this.formsData = {
        ...this.formsData,
        [name]: value,
      };
      console.log();
    },
    onDNValidated: function ({ name, value }) {
      this.formValidation = {
        ...this.formValidation,
        [name]: value,
      };
      console.log({ "this.formValidation": this.formValidation });
    },
    onFormSubmit: function () {
      this.$emit("added", {
        source: this.form_name,
        data: this.formsData,
      });
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-settings-label-add-config {
  .dt-checkbox-control {
    // margin-left: 0px;
    .dt-checkbox {
      max-width: 40px;
      margin: 3px 10px 0px 0px;
    }
  }
}
</style>
